module.exports = __webpack_public_path__ + "static/cheddar-e7c0d59c88ffc50c4947596caaf7db25.svg";